import axios from "axios";
import { ACCESS_TOKEN } from "../local-storage/Contants";
import { isAccessTokenExpire } from "../utils/validate";

var isAbsoluteURLRegex = /^(?:\w+:)\/\//;

axios.interceptors.request.use(async (config) => {



    if (!isAbsoluteURLRegex.test(config.url)) {

  
        if (config.headers['Content-Type'] !== 'multipart/form-data') {
            config.headers = { "Content-Type": "application/json" };
        }


   

        let accessToken =  localStorage.getItem(ACCESS_TOKEN)

        if (accessToken !== null && accessToken !== '' && !isAccessTokenExpire(accessToken)) {
            config.headers["Authorization"] = "Bearer " + accessToken;
        }
        // else
        // {
            
        // }

        config.url = process.env.REACT_APP_BASE_API + config.url;

    }
    return config;

}, error => {

    return Promise.reject(error)
}
);

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return Promise.reject(error.response)
    }
)



export const HttpClient = axios;
